// AUTO-GENERATED SAMPLE PAGE
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const CONFIG: Record<string, { title: string; subtitle: string; icon: string; color: string; content: string[] }> = {
  HoiVienPage: {
    title: 'Danh sách hội viên',
    subtitle: 'Giới thiệu các doanh nghiệp thành viên của Hiệp hội F&B Việt Nam',
    icon: '👥',
    color: '#d97706',
    content: ['Hơn 2,400 doanh nghiệp F&B thành viên trên toàn quốc', 'Chuỗi nhà hàng, quán cafe, thương hiệu F&B uy tín', 'Kết nối B2B, chia sẻ kinh nghiệm trong cộng đồng', 'Tham gia hội nghị, sự kiện ngành thường niên'],
  },
  KhaoSatChuoiPage: {
    title: 'Khảo sát chuỗi nhà hàng F&B',
    subtitle: 'Thống kê số liệu về chuỗi, cửa hàng, doanh thu ngành F&B Việt Nam',
    icon: '📊',
    color: '#7c3aed',
    content: ['Top 50 chuỗi F&B lớn nhất Việt Nam 2024', 'Số liệu doanh thu, số cửa hàng, tăng trưởng', 'Phân tích xu hướng thị trường theo quý', 'Báo cáo cập nhật định kỳ hàng tháng'],
  },
  DangKyHoiVienPage: {
    title: 'Thủ tục đăng ký hội viên',
    subtitle: 'Hướng dẫn quyền lợi hội viên và quy trình tham gia Hiệp hội F&B',
    icon: '📋',
    color: '#db2777',
    content: ['Điền form đăng ký thông tin doanh nghiệp', 'Nộp hồ sơ: GPKD, MST, giấy tờ liên quan', 'Hội đồng xét duyệt trong 5-7 ngày làm việc', 'Nhận thẻ hội viên và quyền lợi đầy đủ'],
  },
  KhaoSatCuaHangPage: {
    title: 'Khảo sát cửa hàng tiện lợi F&B',
    subtitle: 'Dữ liệu cửa hàng tiện lợi F&B trên toàn quốc — cập nhật Thứ Sáu hàng tuần',
    icon: '🏪',
    color: '#15803d',
    content: ['Bản đồ phân bố cửa hàng theo tỉnh thành', 'So sánh mật độ, doanh thu theo khu vực', 'Xu hướng mở/đóng cửa hàng theo quý', 'Cập nhật tiếp theo: Thứ Sáu, 21/03/2025'],
  },
  TaiLieuBaoCaoPage: {
    title: 'Tài liệu & Báo cáo ngành',
    subtitle: 'Đăng ký nhận tài liệu nghiên cứu, báo cáo thị trường F&B Việt Nam',
    icon: '📁',
    color: '#dc2626',
    content: ['Báo cáo thị trường F&B Việt Nam 2024 (PDF)', 'Nghiên cứu hành vi người tiêu dùng F&B', 'Xu hướng công nghệ trong ngành nhà hàng', 'Whitepaper về nhượng quyền F&B tại Đông Nam Á'],
  },
  TrungTamHoTroPage: {
    title: 'Trung tâm hỗ trợ F&B',
    subtitle: 'Tổng đài tư vấn toàn diện về kinh doanh F&B, nhượng quyền, sang nhượng',
    icon: '📞',
    color: '#6d28d9',
    content: ['Hotline 24/7: 1800 FNB (miễn phí)', 'Chat trực tuyến với chuyên gia F&B', 'Đặt lịch tư vấn 1-1 với chuyên gia', 'Cộng đồng hỏi đáp 45,000+ thành viên'],
  },
};

const key = 'KhaoSatChuoiPage' as keyof typeof CONFIG;
const page = CONFIG[key];

export default function KhaoSatChuoiPage() {
  if (!page) return null;
  return (
    <div className="max-w-4xl mx-auto space-y-8 animate-fade-in">
      <Link to="/dich-vu" className="flex items-center gap-1.5 text-sm hover:opacity-70 transition-opacity"
            style={{ color: 'var(--text-3)' }}>
        <ArrowLeft size={14} /> Tất cả dịch vụ
      </Link>

      <div className="rounded-2xl p-8 md:p-12 relative overflow-hidden"
           style={{ background: `linear-gradient(135deg, ${page.color}dd 0%, ${page.color}99 100%)` }}>
        <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(circle at 20% 50%, white 1px, transparent 1px)', backgroundSize: '30px 30px' }} />
        <div className="relative z-10 flex items-start gap-5">
          <div className="w-16 h-16 rounded-2xl bg-white/20 flex items-center justify-center text-4xl shrink-0">
            {page.icon}
          </div>
          <div>
            <h1 className="font-display font-black text-2xl text-white mb-2">{page.title}</h1>
            <p className="text-white/80 text-sm">{page.subtitle}</p>
          </div>
        </div>
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        {page.content.map((item: string, i: number) => (
          <div key={i} className="fnb-card p-5 flex items-start gap-3">
            <div className="w-8 h-8 rounded-lg flex items-center justify-center text-sm font-black text-white shrink-0"
                 style={{ background: page.color }}>
              {i + 1}
            </div>
            <p className="text-sm leading-relaxed" style={{ color: 'var(--text-2)' }}>{item}</p>
          </div>
        ))}
      </div>

      <div className="fnb-card p-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div>
          <p className="font-bold" style={{ color: 'var(--text-1)' }}>Cần thêm thông tin?</p>
          <p className="text-sm mt-0.5" style={{ color: 'var(--text-3)' }}>Liên hệ với đội ngũ FNB HUB để được hỗ trợ</p>
        </div>
        <button className="px-6 py-2.5 rounded-xl text-sm font-semibold text-white shrink-0"
                style={{ background: page.color }}>
          Liên hệ ngay
        </button>
      </div>
    </div>
  );
}
